/**
 * @param action is a string that represents the action that the user is trying to do (ie: 'signup').
 * @returns a recaptcha token string
 */
export const recaptcha = async (action: string): Promise<string> => {
  const grecaptcha = (window as any).grecaptcha;

  const recaptchaKeyId = '6LfkQG0jAAAAANTrIkVXKPfSPHyJnt4hYPWqxh0R';

  return new Promise((resolve, reject) => {
    grecaptcha.enterprise.ready(() => {
      grecaptcha.enterprise.execute(recaptchaKeyId, { action }).then(resolve).catch(reject);
    });
  });
};
